const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* Obdera: running total for the setup-and-activation add-on.
   The add-on is a separate variant, not a line-item property, so ticking the
   box never moved the price and buyers only met the extra charge at the cart,
   where it reads like a surprise fee. This shows the combined figure instead.
   Hosted here because constants.js is small and already loads on product
   pages; if it grows, move it beside the markup in main-product.liquid. */
(function () {
  var LT = (document.documentElement.lang || '').toLowerCase().indexOf('lt') === 0;
  var LABEL = LT ? 'Iš viso' : 'Total';
  var prices = null;

  function money(c) {
    return '€' + (c / 100).toFixed(2).replace('.', ',');
  }

  // Price is read from the label Liquid already renders, so it follows the
  // real add-on price rather than being hard-coded here.
  function addon(box) {
    var l = box.closest('label');
    var m = (l ? l.textContent : '').match(/(\d[\d\s.]*),(\d{2})/);
    return m ? parseInt(m[1].replace(/\D/g, ''), 10) * 100 + parseInt(m[2], 10) : null;
  }

  function render() {
    var boxes = document.querySelectorAll('.setup-service__checkbox');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var wrap = box.closest('.product-form__setup-service');
      var form = box.closest('form');
      if (!wrap || !form) continue;

      var out = wrap.querySelector('.setup-service__total');
      if (!out) {
        out = document.createElement('p');
        out.className = 'setup-service__total caption';
        out.style.fontWeight = '600';
        wrap.appendChild(out);
      }

      var idEl = form.querySelector('[name=id]');
      var base = prices && idEl ? prices[idEl.value] : null;
      var add = addon(box);

      if (!box.checked || base == null || add == null) {
        out.hidden = true;
        continue;
      }
      out.textContent = LABEL + ': ' + money(base + add);
      out.hidden = false;
    }
  }

  var h = (location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
  if (h) {
    fetch('/products/' + h + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        prices = {};
        p.variants.forEach(function (v) { prices[v.id] = v.price; });
        render();
      })
      .catch(function () {});
  }

  // Delegated so it survives the variant picker re-rendering the form.
  document.addEventListener('change', function (e) {
    var direct = e.target && e.target.classList && e.target.classList.contains('setup-service__checkbox');
    setTimeout(render, direct ? 0 : 60);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
